import moment from "moment";

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const generateDates = (innerDate, weeks) => {
  const start = moment(innerDate)
    .startOf("month")
    .startOf("week");

  const end = moment(start)
    .add(weeks, "weeks")
    .endOf("week");

  const dates = [];
  const date = moment(start);
  do {
    dates.push(date.toISOString());
    date.add(1, "day");
  } while (date.valueOf() < moment(end.valueOf()));
  return dates;
};

export const dateToKey = d => moment(d).format("YYYY-MM-DD");
